import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const NavBarLink = ({ children, path, text }) => (
  <S.Link to={path ? `${path}` : '/'} activeClassName="activeNavItem">
    {children}
    <S.LinkText>{text}</S.LinkText>
  </S.Link>
);

export default NavBarLink;

NavBarLink.defaultProps = {
  path: '/',
};

NavBarLink.propTypes = {
  children: PropTypes.node.isRequired,
  path: PropTypes.string,
  text: PropTypes.string.isRequired,
};
